"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeDuplicateItems = void 0;
function mergeDuplicateItems(items) {
    const grouped = {};
    for (const item of (items === null || items === void 0 ? void 0 : items.filter(Boolean)) || []) {
        if (grouped[item.id]) {
            grouped[item.id] = Object.assign(Object.assign({}, grouped[item.id]), item);
        }
        else {
            grouped[item.id] = item;
        }
    }
    return Object.values(grouped);
}
exports.mergeDuplicateItems = mergeDuplicateItems;
//# sourceMappingURL=unique.js.map